import { render, staticRenderFns } from "./SafteList.vue?vue&type=template&id=608c3e12&"
import script from "./SafteList.vue?vue&type=script&lang=js&"
export * from "./SafteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports